import React from "react";
import PropTypes from "prop-types";
import Link from "next/link";
import Image from "next/image";

import { format, parseISO } from "date-fns";
import css from "../../css/find-agent/blog.module.css";
import thumb from "../../static/img/blog-thumb.png";

class BlogPost extends React.PureComponent {
    render() {
        const { url, image, blog_category, title, brief, date, author } =
            this.props.blog;

        const createdDate = format(parseISO(date), "MMM do, yyyy");

        return (
            <div className={css.post}>
                <div className={css.thumb}>
                    <Link href={`/blog?blog=${url}`} as={`/blog/${url}`}>
                        {image ? (
                            <img src={image.s200} alt={title} />
                        ) : (
                            <Image src={thumb} alt={title} />
                        )}
                    </Link>
                </div>
                <div className={css.content}>
                    <div className={css.category}>{blog_category.label}</div>
                    <h5 className={css.title}>
                        <Link href={`/blog?blog=${url}`} as={`/blog/${url}`}>
                            {title}
                        </Link>
                    </h5>
                    <div className={css.text}>{brief}</div>
                    <div className={css.author}>
                        {createdDate}{" "}
                        {author && (
                            <>
                                by{" "}
                                <span className={css.authorName}>{author}</span>
                            </>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

BlogPost.propTypes = {
    blog: PropTypes.object.isRequired,
};

export default BlogPost;
